// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1eJjT","errors":"Errors_errors__3WThJ"};